import React, { useEffect, useState } from 'react';
import styles from '../../pages/DealTaxes/components/styles.module.css';
import ToggleIcon from '../ToggleIcon/ToggleIcon';
import { Button } from '../Button';
import selectionStyles from '../SelectedCombination/selected-combination.module.css';

export const asideMenuSelectionMenuGroups = {
    investors: 'investors',
    selection: 'selection',
    checkboxes: 'checkboxes',
    checkboxesGrouped: 'checkboxesGrouped',
};

const AsideMenuSelectionMenuGroup = ({
    icon,
    label,
    openCategory,
    category,
    setOpenCategory,
    children,
    contentHeight,
    onEdit,
    backButton,
}: any) => {
    const [isOpen, setIsOpen] = useState(openCategory === category);
    const [isInternallyOpen, setIsInternallyOpen] = useState(true);

    useEffect(() => {
        if (window.innerHeight > contentHeight) {
            setIsOpen(isInternallyOpen);
        } else {
            setIsOpen(openCategory === category);
        }
    }, [contentHeight, isInternallyOpen, openCategory]);

    const toggleOpen = () => {
        setOpenCategory(category);
        setIsInternallyOpen(!isInternallyOpen);
    };

    return (
        <div className={`${styles.group} ${isOpen ? styles.open : ''}`}>
            <div className={`${styles.groupHeader} ${selectionStyles.rowGrid}`} onClick={toggleOpen}>
                <ToggleIcon isActive={isOpen} />

                <span>{label}</span>
            </div>
            {isOpen && (
                <div className={`${styles.groupContent} ${styles[category]}`}>
                    {children}

                    {onEdit && (
                        <div className={styles.btnContainer}>
                            <Button type={'button'} color={'neutral'} size={'sm'} onClick={onEdit}>
                                Edit
                            </Button>
                        </div>
                    )}

                    {backButton && <div className={styles.btnContainer}>{backButton}</div>}
                </div>
            )}
        </div>
    );
};

export default AsideMenuSelectionMenuGroup;
